// extracted by mini-css-extract-plugin
module.exports = {"container":"MultiChoiceButtons_container__euy9T"};